/* Built In Imports */

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import GoogleMap from '@components/Embeds/GoogleMap';
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* Services */

const HowtoGetthere = ({ section, region, lang }) => {
  const sectionContent = section?.sectionContent;

  return (
    <Box py={{ base: '25px', md: '40px' }} height="100%" w={{base: '100%', md:'970px'}} m="0 auto">
      <SectionTitle
        titleObj={sectionContent[0]}
        maxW="360px"
        lineHeight="120%"
      />
      <MidContainer>
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          mb="30px"
          justifyContent={{ base: 'center', lg: 'space-between' }}
        >
          <Box
            maxW={{ base: '100%', lg: '410px' }}
            mr={{ base: '0', md: '40px' }}
            pt={{ base: '20px', lg: '1%' }}
            pb="30px"
            m={{ base: '0 16px', lg: '0' }}
          >
            <StructuredTextParser
              str={render(section?.sectionContent[2]?.body)}
              color="#000"
              mt="0"
              fontSize={{ base: '16px'}}
              lineHeight={{ base: '26px', md: '30px' }}
              fontFamily="FedraSansStd-book"
              fontWeight="400"
              className="placetext"
            />
          </Box>
          <Box width={{ base: 'auto', lg: '500px' }}>
            <GoogleMap sectionContent={sectionContent[1]} ht="280px" />
          </Box>
        </Flex>
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          mb="30px"
          justifyContent={{ base: 'center', lg: 'space-between' }}
        >
          <Box
            maxW={{ base: '100%', lg: '410px' }}
            mr={{ base: '0', md: '40px' }}
            pt={{ base: '20px', lg: '1%' }}
            pb="30px"
            m={{ base: '0 16px', lg: '0' }}
          >
            <StructuredTextParser
              str={render(section?.sectionContent[4]?.body)}
              color="#000"
              mt="0"
              fontSize={{ base: '16px'}}
              lineHeight={{ base: '26px', md: '30px' }}
              fontFamily="FedraSansStd-book"
              fontWeight="400"
              className="placetext"
            />
          </Box>
          <Box width={{ base: 'auto', lg: '500px' }}>
            <GoogleMap sectionContent={sectionContent[3]} ht="280px" />
          </Box>
        </Flex>
      </MidContainer>  
      <style global jsx>
              {`
                .placetext p a {
                  color: #7E323B;
                  text-decoration: underline;
                }
                .placetext p {
                  margin-bottom: 10px;
                }
                .placetext h6 {
                    font-size: 20px;
                    font-weight: bold;
                    padding: 0 0 20px 0;
                }
              `}
        </style>
    </Box>
  );
};

export default HowtoGetthere;
